import molin_6 from '../../assets/images/tra/molin_6.webp';
import molin_7 from '../../assets/images/tra/molin_7.webp';
import MolinHeader from '../../components/MolinHeader';
import { useState } from 'react';
import '../../styles/common.css'
export default function StallTrading() {
    const [storyStatus, setStoryStatus] = useState(0);
    return (
        <div className="relative">
            <MolinHeader></MolinHeader>

            {storyStatus < 1 && (
                <div>
                    <img src={molin_6} alt="Hero background" className="w-full h-auto" />
                    <div className="top-[30%] absolute left-[39%] w-[26%] z-[9999] text-left">
                        <div className="flex flex-col">
                            <span className="text-[#000000] text-[2.6vw]">设摊</span>
                            <span className="text-[#000000] text-[2.6vw] mt-[-0.8vw]">交易</span>
                            <span className="text-[#000000] text-[1vw] ml-[0.5vw] mt-[-0.2vw]">Stall Trading</span>
                            <span className="text-[#000000] text-[0.9vw] mt-[5.4vw] leading-[1.3vw] text-justify">明中叶，江浙一带的古玩艺术市场已初具规模，不仅出现了固定的店肆、古董铺，还出现了带有集市性质的设摊交易。                            </span>
                            <span className="text-[#000000] text-[0.7vw] mt-[1.6vw] leading-[1vw] text-justify">By the mid-Ming dynasty, the antique art market in the Jiangnan and Zhejiang regions had already taken shape. Not only did fixed shops and antique stores emerge, but market-style stall transactions also became common, reflecting a thriving and organized commercial network for collecting and trading art.</span>
                        </div>
                    </div>
                    <div className='absolute bottom-[22%] left-[47%] h-auto w-[10vw] transition-transform duration-300 hover:scale-110 cursor-pointer animate-breathe-enter'
                        onClick={() => setStoryStatus(1)}>
                        <div className="flex flex-col text-center">
                            <span className="text-[#000000] text-[1.3vw]">进入</span>
                            <span className="text-[#000000] text-[1vw]">Enter</span>
                        </div>
                    </div>
                </div>
            )}
            {storyStatus >= 1 && (
                <img src={molin_7} alt="Hero background" className="w-full h-auto" />
            )}

            {storyStatus === 1 && (
                <div className="top-[40%] left-[65%] absolute">
                    <button className="rounded-full breathe-l bg-transparent animate-breathe shadow-lg transition-all cursor-pointer"
                        onClick={() => setStoryStatus(2)}>
                    </button>
                </div>
            )}
            {storyStatus >= 2 && (
                <div className={`chat-bubble-base absolute top-[30%] left-[65%] transform -translate-x-1/2 chat-bubble-right 
                    chat-bubble-fade-in ${storyStatus >= 2 ? 'chat-bubble-fade-in-active' : ''}`}>
                    <span className='mt-[1vw] typing-effect'>“走过的客官们瞧一瞧，小店新上市精品瓷器古玩！”</span>
                    <span className='mb-[1vw] typing-effect'>"Ladies and gentlemen, come and take a look! The finest porcelain antiques are now available at this humble shop!"</span>
                </div>
            )}
        </div>
    )
}